import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useMediaQuery, Typography } from '@material-ui/core';
import clsx from 'clsx';

// COMPONENTS
import RouterBreadcrumbs from '@/components/RouterBreadcrumbs';
import Sticky from '@/components/Sticky';

// STYLES
import { Container } from './styles';

const ContentHero = ({
  title,
  titleProps,
  subtitle,
  breadcrumbsProps,
  hideBreadcrumbs,
  children,
  leftBg,
  rightBg,
  useBrandedDefaults,
}) => {
  const { headerHeight, partner, partnerSettings } = useSelector(state => ({
    headerHeight: state.app.headerHeight,
    partner: state.partner.data,
    partnerSettings: state.partner.data?.settings || {},
  }));
  const matchesSmDown = useMediaQuery(({ breakpoints }) => breakpoints.up('sm'));

  useEffect(() => {
    // Just hack for better Sticky component bahaviour
    setTimeout(() => {
      if (window.scrollTo) window.scrollTo(0, 2);
    }, 100);
  }, []);

  const hasTheme = !!partner.theme;
  const useDarkContentHero = !!partner.theme?.useDarkContentHero;
  const subHeader =
    !partnerSettings.is_fake &&
    (partnerSettings.header_type === 'current_with_bar' ||
      partnerSettings.header_type === 'current_with_bar_and_reordered_links');
  const stickyTop = subHeader && headerHeight !== 0 ? 104 : headerHeight;
  const useLighten = useBrandedDefaults || !(hasTheme && useDarkContentHero);

  return (
    <Container
      className={clsx(
        'content-hero',
        leftBg && 'content-hero--left-bg',
        rightBg && 'content-hero--right-bg',
        useBrandedDefaults && 'content-hero--default-brand',
        useLighten && 'content-hero--lighten',
      )}
    >
      <div className="page-content">
        {!hideBreadcrumbs && (
          <RouterBreadcrumbs
            className={clsx(useLighten && 'breadcrumbs breadcrumbs--light')}
            {...breadcrumbsProps}
          />
        )}
        {title && (
          <Typography
            className="content-hero__title"
            component="h1"
            variant={matchesSmDown ? 'h3' : 'h4'}
            {...titleProps}
          >
            {title}
          </Typography>
        )}
        {subtitle && <Typography className="content-hero__subtitle">{subtitle}</Typography>}
        {children && (
          <Sticky top={stickyTop} innerZ={1211}>
            <div className="content-hero__content">{children}</div>
          </Sticky>
        )}
      </div>
    </Container>
  );
};

ContentHero.defaultProps = {
  title: '',
  subtitle: '',
  titleProps: {},
  breadcrumbsProps: {},
  hideBreadcrumbs: false,
  leftBg: false,
  rightBg: false,
  useBrandedDefaults: false,
};

ContentHero.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  titleProps: PropTypes.object,
  subtitle: PropTypes.string,
  breadcrumbsProps: PropTypes.object,
  hideBreadcrumbs: PropTypes.bool,
  leftBg: PropTypes.bool,
  rightBg: PropTypes.bool,
  useBrandedDefaults: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default React.memo(ContentHero);
